import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Vuelve al inicio en cada navegación. Respeta anclas (#algo) para no romper deep links.
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.key, location.hash]);

  return null;
};

export default ScrollToTop;
